import { getRawCookieByName } from './getRawCookieByName'; // fixed import path

const setAXPLocaleCookie = (nextLocale) => {
  if (typeof document === 'undefined' || !nextLocale) {
    // If document is not defined, we are likely in a server-side context
    // and should not attempt to set a cookie.
    // Also, if nextLocale is not provided, we should not set the cookie.
    return;
  }
  try {
    // This is to ensure that the cookie is only set when necessary
    // and to avoid unnecessary cookie updates
    const { value } = getRawCookieByName(document.cookie, 'axplocale') || {};
    if (nextLocale && value !== nextLocale) {
      // If the cookie already exists and the new locale is different, update it
      document.cookie = `axplocale=${nextLocale}; path=/ ;domain=.americanexpress.com`;
    }
  } catch (error) {
    // Optionally log error for debugging
    // console.error('Failed to set axplocale cookie:', error);
  }
};

export default setAXPLocaleCookie;
